/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Automation_Action_Create_TaskInputs */

const en_automation_action_create_task = /** @type {(inputs: Automation_Action_Create_TaskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Create ${i?.task}`)
};

const pt_br2_automation_action_create_task = /** @type {(inputs: Automation_Action_Create_TaskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Criar ${i?.task}`)
};

/**
* | output |
* | --- |
* | "Create {task}" |
*
* @param {Automation_Action_Create_TaskInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_action_create_task = /** @type {((inputs: Automation_Action_Create_TaskInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Action_Create_TaskInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_action_create_task(inputs)
	return pt_br2_automation_action_create_task(inputs)
});